import { parseDate } from "../common/Hooks";
import { BankAccountAttributes } from "../attributes/bank-account-attributes";

class BankAccount {
  id: number;
  rib_number: string;
  bic_number: string;

  assignment_date: Date | null;

  constructor(
    id: number,
    rib_number: string,
    bic_number: string,
    assignment_date: Date | null
  ) {
    this.id = id;
    this.rib_number = rib_number;
    this.bic_number = bic_number;
    this.assignment_date = assignment_date;
  }

  static fromJson(json: BankAccountAttributes): BankAccount | null {
    if (json === null || json === undefined) {
      return null;
    }

    return new BankAccount(
      json.id,
      json.rib_number,
      json.bic_number,
      parseDate(json.assignment_date)
    );
  }
}

export default BankAccount;
